import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
//import {formValueSelector} from 'redux-form';
import {I18n} from 'react-redux-i18n';

import customer from '../../customer';
const {getActivePermissions, getIsPaperSizeLetter, getUsePLUCode, getUseUSMetrics, getLabelTitleOrder, getActivePageOffset, getIsEnglish } = customer.selectors;

import {saveLabelSettings, clearLabelSheet} from '../actions';
import CloseButton from './CloseButton';
//import {areSettingsValid, getStoreSettings} from '../selectors';

import AdvancedSettingsForm from './AdvancedSettingsForm';

//import * as permissions from '../../common/userPermissions';

const formName = 'advancedSettingsForm';
//const formSelector = formValueSelector(formName);

class AdvancedSettingsPage extends React.Component {
  componentWillMount() {
  /*  const accessPermission = this.props.activePermissions.find((permission) => {
      return permission === permissions.MANAGE_LOGO;
    });
    if(!accessPermission)
    {
      this.props.actions.push('/labels');
    } 

    this.props.actions.getCareSheetSettings();
    */
  }

 // componentWillReceiveProps(nextProps) {
 /*   if(this.props.authData.activeSubscriptionId !== nextProps.authData.activeSubscriptionId) {
      this.props.actions.getCareSheetSettings();
    }
    */
  //}

  handleCancel = () => {
    this.props.actions.push('/labels');
  }

  handleFormSubmit = (values) => {
    this.props.actions.saveLabelSettings(values.IsPaperSizeLetter,values.UsePLUCode ,values.UseUSMetrics, values.LabelTitleOrder  , values.pageOffset.PosY, values.pageOffset.PosX);
    this.props.actions.clearLabelSheet();
    this.props.actions.push('/labels');

   
    /* return new Promise((resolve, reject) => {
      this.props.actions.saveLabelSettings(values.IsPaperSizeLetter,values.UsePLUCode ,values.UseUSMetrics, values.LabelTitleOrder  , values.VerticalOffset, values.HorizontalOffset)
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    }); */

  }

  render() {
   // const {actions: {uploadLogo}, useLogo, storeSettings, validSettings} = this.props;
   const validSettings = true;
   let test = this.props.isEnglish;
   if(test)
    test=false;

    return(
      <div className="container-fluid main full-width" id="main">
        <div className="row">
          <div className="col-lg-12">
            <h1 className="float-left">{I18n.t('ADVANCED_SETTINGS_LABEL_PAGE_TITLE')}</h1>
            <CloseButton url="/labels"/>
            </div>
            <div className="col-lg-12">
            <p> </p>
            {!validSettings && <div className="loading"/>} 
            {validSettings && <div><div className="row no-gutters">
            
            </div> 

            <AdvancedSettingsForm form={formName} 
                           initialValues={{IsPaperSizeLetter: this.props.isPaperSizeLetter, 
                           UsePLUCode: this.props.usePLUCode,
                           UseUSMetrics: this.props.useUSMetrics, 
                           LabelTitleOrder: this.props.labelTitleOrder,
                          
                          pageOffset:this.props.pageOffset}}
                           onSubmit={this.handleFormSubmit}
                            handleCancel={this.handleCancel}
/*                            storeSettings={{IsPaperSizeLetter: this.props.isPaperSizeLetter, 
                            UsePLUCode: this.props.usePLUCode,
                            UseUSMetrics: this.props.useUSMetrics, 
                            LabelTitleOrder: this.props.labelTitleOrder}}
                           useLogo={true}  */
                           isEnglishIn={this.props.isEnglish}
                           />
            
            </div>}
          </div>
        </div>
      </div>
    );
  }
}
  
function mapStateToProps(state) {
  return {
    activePermissions: getActivePermissions(state),
   // useLogo: formSelector(state, 'useLogo'),
    isPaperSizeLetter:getIsPaperSizeLetter(state),
    useUSMetrics:getUseUSMetrics(state),
    usePLUCode:getUsePLUCode(state),
    labelTitleOrder:getLabelTitleOrder(state),
    pageOffset: getActivePageOffset(state),
    isEnglish: getIsEnglish(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
   // actions: bindActionCreators({getCareSheetSettings, uploadLogo, saveStoreSettings, push}, dispatch)
    actions: bindActionCreators({saveLabelSettings,clearLabelSheet, push}, dispatch)
  };
}



AdvancedSettingsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  activePermissions: PropTypes.array.isRequired,
  authData: PropTypes.object.isRequired,
  isPaperSizeLetter:PropTypes.bool.isRequired, 
  usePLUCode: PropTypes.bool.isRequired, 
  useUSMetrics: PropTypes.bool.isRequired, 
  labelTitleOrder: PropTypes.number.isRequired,
  pageOffset: PropTypes.object.isRequired,
  isEnglish: PropTypes.bool.isRequired,
};

AdvancedSettingsPage.defaultProps = {
  usePLUCode:true,
  useUSMetrics:false,
  isPaperSizeLetter:false,
  labelTitleOrder:0,
  isEnglish:false

};

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedSettingsPage);


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/AdvancedSettingsPage.js
 **/